export const environment = {
  production: true,
  // pouchDbUrl: 'https://db.mc.zduniak.net/',
  pouchDbUrl: 'https://couchdb.mc2020.ellipsis.es/',
  GOOGLE_API_KEY: 'AIzaSyBqDOLRero8bDzj1VMOzkLqiY4-laS9Kbg',
  isAdmin: window.location.host.search(/.+\-webapp/) === 0,
  hostToSeasonSyncDbNameMap: {
    // mc
    'mc2025.nickesh.pl': 'league(mc)-season(2025)',
    'mc2026.nickesh.pl': 'league(mc)-season(2026)',
    'mc-webapp.nickesh.pl': 'league(mc)-season(2026)',

    // Production environment tests:
    'localhost:4200': 'league(mc)-season(2026)-test',
    'mc-webapp:4200': 'league(mc)-season(2026)-test',
    'mcs-webapp:81': 'league(mc)-season(2026)-test',
    '192.168.0.38:4200': 'league(mc)-season(2026)-test',

    // mmc
    'mmc2025.nickesh.pl': 'league(mmc)-season(2025)',
    'mmc2026.nickesh.pl': 'league(mmc)-season(2026)',
    'mmc-webapp.nickesh.pl': 'league(mmc)-season(2026)',
    // mc-rookie
    'mc-rookie2025.nickesh.pl': 'league(mc-rookie)-season(2025)',
    'mc-rookie2026.nickesh.pl': 'league(mc-rookie)-season(2026)',
    'mc-rookie-webapp.nickesh.pl': 'league(mc-rookie)-season(2026)',
    // tac
    'tac2025.nickesh.pl': 'league(tac)-season(2025)',
    'tac2026.nickesh.pl': 'league(tac)-season(2026)',
    'tac-webapp.nickesh.pl': 'league(tac)-season(2026)',
    // tm
    'tm2025.nickesh.pl': 'league(tm)-season(2025)',
    'tm2026.nickesh.pl': 'league(tm)-season(2026)',
    'tm-webapp.nickesh.pl': 'league(tm)-season(2026)',
    // ac
    'ac2025.nickesh.pl': 'league(ac)-season(2025)',
    'ac2026.nickesh.pl': 'league(ac)-season(2026)',
    'ac-webapp.nickesh.pl': 'league(ac)-season(2026)',
    // tr
    'tr2025.nickesh.pl': 'league(tr)-season(2025)',
    'tr2026.nickesh.pl': 'league(tr)-season(2026)',
    'tr-webapp.nickesh.pl': 'league(tr)-season(2026)',
    // inordic
    'inordic.nickesh.pl': 'league(inordic)-season(2026)',
    'inordic2026.nickesh.pl': 'league(inordic)-season(2026)',
    'inordic-webapp.nickesh.pl': 'league(inordic)-season(2026)'
  },
  tagReadingsURL: 'http://192.168.1.151/user_apps/lista.txt',
  tagReadingsURLPollingTailBytes: 5000
};

if (environment.isAdmin) {
  environment.pouchDbUrl = environment.pouchDbUrl.replace(/^(https?:\/\/)/, '$1' + 'admin:B_)-9g=FL052' + '@')
}
